export default __webpack_public_path__ + "static/media/Group 2140.57737a4e.svg";